<template>
  <div class="w-[930px] mx-auto">
    <div>
      <h1 class="text-4xl text-center">Garrett Lees</h1>
      <p class="text-center">Actor & Autism Advocate<br />
        <span class="italic">
          <a class="hover:text-blue-400 text-blue-700" href="#" @click="showAboutMe()">
            About Me
          </a>
          &mdash;
          <a class="hover:text-blue-400 text-blue-700" href="/static/GarrettLees-Resume-public-20240914.pdf"
            target="_blank">
            Download Resume
          </a>
          &mdash;
          <a class="hover:text-blue-400 text-blue-700" href="mailto:garrlees@msmu.edu">Contact Me</a>
        </span>
      </p>
    </div>
    <div class="flex flex-col h-dvh z-10">
      <div class="grid grid-rows-4 grid-cols-3 mt-4">
        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('sovereign')">
            <img v-bind:src="'thumbnails/sovereign-td2.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">The Sovereign</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('date-for-update')">
            <img v-bind:src="'thumbnails/date-for-update.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">A Date for an Update</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('spectrum-of-you')">
            <img v-bind:src="'thumbnails/spectrum-of-you.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">The Spectrum of You</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('high-school')">
            <img v-bind:src="'thumbnails/high-school-never-ends.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">High School Never Ends</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('janis-ian')">
            <img v-bind:src="'thumbnails/janis-ian.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">Janis Ian: Breaking Silence</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('healthy-world')">
            <img v-bind:src="'thumbnails/a-healthy-world.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">A Healthy World</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('living-among-giants')">
            <img v-bind:src="'thumbnails/living-among-giants.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">Living Among Giants</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('village-ws')">
            <img v-bind:src="'thumbnails/voice-acting-commercial.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">Voice Acting and Commercials</p>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative group inline-block" @click="showDetail('epic-players')">
            <!--          <div class="relative group inline-block"> -->
            <img v-bind:src="'thumbnails/epic-players.jpg'" />
            <div class="absolute opacity-0 group-hover:opacity-100 top-1/2 left-1/2 transform bg-slate-600/40
            rounded-lg -translate-x-1/2 -translate-y-1/2 text-center transition-opacity delay-100 duration-500">
              <p class="font-semibold text-2xl my-1 text-white">Epic Players Live Performance</p>
            </div>
          </div>
        </div>
        <div class="col-span-3">
          <p class="text-center">
            <span class="italic">
              <a class="hover:text-slate-700 text-slate-400 px-10" title="Facebook" target="_blank"
                href="https://www.facebook.com/garrett.s.lees">
                <i class="fab fa-facebook"></i>
              </a>
              <a class="hover:text-slate-700 text-slate-400 px-10" title="Vimeo" target="_blank"
                href="https://vimeo.com/474236038" >
                <i class="fab fa-vimeo"></i>
              </a>
              <a class="hover:text-slate-700 text-slate-400 px-10" title="Instagram" target="_blank"
                href="https://www.instagram.com/leesgarrett" >
                <i class="fab fa-instagram"></i>
              </a>
              <a class="hover:text-slate-700 text-slate-400 px-10" title="Linked In" target="_blank" 
                href="https://www.linkedin.com/in/garrett-lees-058756196/">
                <i class="fab fa-linkedin"></i>
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="absolute w-[1000px] h-[560px] rounded-xl top-25 mx-auto inset-0 flex justify-center
           items-center bg-neutral-200/60 z-20" :class="{ invisible: overlayHidden }">
      <button
        class="btn btn-md text-white text-xl btn-ghost font-extrabold btn-circle hover:bg-slate-600/80 bg-slate-600/60 absolute right-1 top-1"
        @click="closeClip">X</button>
      <video id="video_player" ref="video_player" width="880" height="495" disablepictureinpicture autoplay controls
        preload="none" @ended="videoClipEnded()">
        <source v-bind:src=videoUrls[currentSelection] type="video/mp4">
      </video>
    </div>

    <div id="detail_div" ref="detail_div" class="absolute w-[1000px] h-[560px] rounded-xl top-25 mx-auto inset-0 flex justify-center
           items-center bg-neutral-200/0 transition-opacity duration-1500 z-20" v-if="currentSelection"
      :class="{ invisible: detailHidden.hidden, 'opacity-0': detailHidden.transparent, 'opacity-100': !detailHidden.transparent }">
      <button
        class="btn btn-md text-white text-xl btn-ghost font-extrabold btn-circle hover:bg-slate-600/80 bg-slate-600/50 absolute right-1 top-1"
        @click="closeDetail">X</button>
      <div id="detail_view" class="bg-contain bg-slate-600/50 justify-center items-center w-[880px] h-[495px]"
        :style="{ 'background-image': 'url(/posters/' + currentSelection + '-fade.jpg)' }" ref="detail_view">
        <h1 class="text-4xl font-bold text-center text-white mx-4 my-4">{{ selectionDetail.full_title }}</h1>
        <div class="text-white text-xl font-normal mx-4 my-4">
          <p class="mb-2">
            <span class="font-bold">Role:</span><br>{{ selectionDetail.role }}
          </p>
          <p class="mb-2">
            <span class="font-bold">Synopsis:</span><br>
            {{ selectionDetail.synopsis }}
          </p>
        </div>
        <div class="absolute bottom-10 left-40 text-white text-xl font-normal mx-4 my-4">
          <span class="italic">
            <a class="hover:text-yellow-500 text-yellow-300 mr-40" href="#" @click="showClip(currentSelection)">
              Watch clip
            </a>
            <span v-if="selectionDetail.show_award_link">
              <a class="hover:text-yellow-500 text-yellow-300 mr-40" href="#" @click="showAwards(currentSelection)">
                Awards
              </a>
            </span>
            <span v-if="selectionDetail.show_full_film_link">
              <a class="hover:text-yellow-500 text-yellow-300" :href="selectionDetail.full_film_url" target="_blank">
                Get full film
              </a>
            </span>
          </span>
        </div>
      </div>
    </div>

    <div id="award_div" ref="award_div" class="absolute w-[1000px] h-[560px] rounded-xl top-25 mx-auto inset-0 flex justify-center
           items-center bg-neutral-200/0 transition-opacity duration-1500 z-20" v-if="currentSelection"
      :class="{ invisible: awardHidden.hidden, 'opacity-0': awardHidden.transparent, 'opacity-100': !awardHidden.transparent }">
      <button
        class="btn btn-md text-white text-xl btn-ghost font-extrabold btn-circle hover:bg-slate-600/80 bg-slate-600/50 absolute right-1 top-1"
        @click="closeAwards">X</button>
      <div id="detail_view" class="bg-contain bg-slate-600/50 justify-center items-center w-[880px] h-[495px]"
        :style="{ 'background-image': 'url(/posters/' + currentSelection + '-fade.jpg)' }" ref="detail_view">
        <h1 class="text-4xl font-bold text-center text-white mx-4 my-4">{{ selectionDetail.full_title }} &mdash; Awards
        </h1>
        <ul class="text-white text-xl font-medium mx-4 my-4 list-disc list-inside">
          <li v-for="award in selectionDetail.awards">{{ award }}</li>
        </ul>
      </div>
    </div>

    <div id="about_div" ref="about_div" class="absolute w-[1000px] h-[560px] rounded-xl top-25 mx-auto inset-0 flex justify-center
           items-center bg-neutral-200/0 transition-opacity duration-1500 z-20"
      :class="{ invisible: aboutHidden.hidden, 'opacity-0': aboutHidden.transparent, 'opacity-100': !aboutHidden.transparent }">
      <button
        class="btn btn-md text-white text-xl btn-ghost font-extrabold btn-circle hover:bg-slate-600/80 bg-slate-600/50 absolute right-1 top-1"
        @click="closeAboutMe">X</button>
      <div id="about_view" class="bg-slate-600/90 justify-center items-center w-[880px] h-[495px]" ref="about_view">
        <h1 class="text-3xl font-bold text-center text-white mx-4 my-4">About Me</h1>
        <div class="text-white text-xl font-normal mx-4 my-4">
          <img class="float-left mr-4" width="240" v-bind:src="'posters/GLHeadshot.jpg'" />
          <p class="mb-2"><span class="font-semibold">Garrett Lees</span> is an LA based actor who is passionate about
            acting and promoting diversity. He has performed in features, shorts, and documentaries and is a proud
            member of
            EPIC Players LA - a neuro-diverse theater troupe.
          </p>
          <p class="mb-2">
            He appeared in <i>The Sovereign</i>, a full-length feature, and also short films such as <i>The Spectrum of
              You</i>
            and <i>A Date for an Update</i>.
            He has also been in multiple live performances with the EPIC Players, including two recent variety shows
            and a storytelling workshop.
          </p>
          <p class="mb-2">
            He is honored to share his talent and his enthusiasm for inclusion and authentic representation of
            neuro-diverse characters.
            He has been acting in films with his friends on the autism spectrum since he was 10 years old.
            He is dedicated to promoting the dramatic arts as an effective and enjoyable avenue for fostering inclusion.
          </p>
        </div>
      </div>
    </div>
  </div>
  <dialog id="video_modal" ref="video_modal" class="modal">
    <div class="modal-box w-11/12 max-w-5xl">
      <video id="video_player2" class="z-15" ref="video_player" width="900" height="506" autoplay controls
        preload="none">
        <source v-bind:src=videoUrls[currentSelection] type="video/mp4">
        Your browser does not support the video tag.
      </video>
      <div class="modal-action">
        <form method="dialog">
          <button class="btn btn-sm btn-circle btn-ghost absolute text-white right-2 top-2"
            @click="closeDetail">x</button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup>
import { ref } from "vue";
import ky from 'ky';
import { transcode } from "buffer";
var currentSelection = ref("");
var selectionDetail = ref("");
var overlayHidden = ref(true);
var detailHidden = ref({ hidden: true, transparent: true });
var awardHidden = ref({ hidden: true, transparent: true });
var aboutHidden = ref({ hidden: true, transparent: true });
var videoUrls = ref(
  {
    "date-for-update": "https://www.garrettlees.com/static/video/DateForAnUpdateShort.mp4",
    "epic-players": "https://www.garrettlees.com/static/video/G.Lees_EpicCatalinaClub.mp4",
    "janis-ian": "https://www.garrettlees.com/static/video/JanisIan_GarrettLees.mp4",
    "high-school": "https://www.garrettlees.com/static/video/HighSchoolNeverEnds.mp4",
    "sovereign": "https://www.garrettlees.com/static/video/TheSovereignAndyShort.mp4",
    "spectrum-of-you": "https://www.garrettlees.com/static/video/SpectrumOfYou.mp4",
    "village-ws-and-epic-mono": "https://www.garrettlees.com/static/video/VillageWSAndEpicMonologue.mp4",
    "village-ws": "https://www.garrettlees.com/static/video/VillageWorkspaces.mp4",
    "healthy-world": "https://www.garrettlees.com/static/video/HealthyWorld.mp4",
    "living-among-giants": "https://www.garrettlees.com/static/video/LivingAmongGiants.mp4"
  })

function showDetail(thumb, event) {
  console.log("static/" + thumb + ".json");
  ky.get("https://www.garrettlees.com/static/" + thumb + ".json").then(
    response => response.json().then(selectionInfo => (selectionDetail.value = selectionInfo)));
  console.log(thumb);
  currentSelection.value = thumb;
  //overlayHidden.value = false;
  detailHidden.value.hidden = false;
  detailHidden.value.transparent = false;
  //  video_modal.showModal();
  video_player.disablepictureinpicture = true;
  console.log(video_player.disablepictureinpicture);
  // video_player.load();
}

function closeDetail(event) {
  console.log("Closing dialog for: ", currentSelection.value);
  console.log(selectionDetail.value);
  overlayHidden.value = true;
  detailHidden.value.transparent = true;
  setTimeout(function () { detailHidden.value.hidden = true; }, 1500);
  video_player.pause();
}

function showClip(thumb, event) {
  console.log(thumb);
  currentSelection.value = thumb;
  detailHidden.value.transparent = true;
  setTimeout(function () { detailHidden.value.hidden = true; }, 1500);
  overlayHidden.value = false;
  video_player.disablepictureinpicture = true;
  console.log(video_player.disablepictureinpicture);
  video_player.load();
}

function closeClip(event) {
  console.log("Closing dialog for: ", currentSelection.value);
  detailHidden.value.transparent = false;
  detailHidden.value.hidden = false;
  setTimeout(function () { overlayHidden.value = true; }, 1500);
  video_player.pause();
}

function videoClipEnded(event) {
  console.log("Video for " + currentSelection.value + " ended.");
  closeClip(event);
}

function showAwards(thumb, event) {
  console.log(thumb);
  currentSelection.value = thumb;
  detailHidden.value.transparent = true;
  setTimeout(function () { detailHidden.value.hidden = true; }, 1500);
  awardHidden.value.hidden = false;
  awardHidden.value.transparent = false;
}

function closeAwards(event) {
  console.log("Closing dialog for: ", currentSelection.value);
  detailHidden.value.hidden = false;
  detailHidden.value.transparent = false;
  awardHidden.value.transparent = true;
  setTimeout(function () { awardHidden.value.hidden = true; }, 1500);
}

function showAboutMe(event) {
  console.log("Showing about me...");
  aboutHidden.value.hidden = false;
  aboutHidden.value.transparent = false;
}

function closeAboutMe(event) {
  console.log("Closing dialog for: About Me");
  aboutHidden.value.hidden = true;
  aboutHidden.value.transparent = true;
}
</script>

<style lang="css">
#app {
  font-size: 18px;
  margin-left: 15px;
  margin-top: 10px;
  margin-right: 15px;
}

.red-div {
  background-color: red;
}
</style>
